import React, { useState, useEffect } from "react";
import {
  ChakraProvider,
  Box,
  Button,
  FormControl,
  Input,
  FormHelperText,
  Select,
} from "@chakra-ui/react";
import "./CallbackForm.css";
import "react-international-phone/style.css";
import axios from "axios";
import MobileNumberInput from "./MobileNumberInput";

const CallbackForm = ({ onFormSubmit }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    mobile: "",
    isd: "",
    email: "",
    company: "",
    industry: "",
  });

  const [emailError, setEmailError] = useState(false);
  const [country, setCountry] = useState('us');
  const [countryDialCode, setCountryDialCode] = useState('346');
  const [phone, setPhone] = useState('');


  useEffect(() => {
    const currentUrl = window.location.href;
    setFormData((prevState) => ({
      ...prevState,
      lead_source_url: currentUrl,
    }));
    console.log("Current url", currentUrl);
  }, []);



  

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    if (e.target.name === "email") {
      setEmailError(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate email format
    if (!validateEmail(formData.email)) {
      setEmailError(true);
      return;
    }

    let data = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      mobile: phone,
      isd: countryDialCode,
      email: formData.email,
      company: formData.company,
      industry: formData.industry,
      lead_source_url: formData.lead_source_url,
    };

    var dData = new FormData();
    for (var i in data) {
      dData.append(i, data[i]);
    }

    try {
      const response = await axios.post(
        "https://shik-admin.zolute.xyz/api/projectLead",
        dData
      );

      console.log("Form submitted successfully:", response.data);

      onFormSubmit();
    } catch (error) {
      if (error.response) {
        console.error("API call failed with response:", error.response.data);
        alert(`Something went wrong: ${error.response.data.message}`);
      } else if (error.request) {
        console.error("API call failed with request:", error.request);
        alert("No response received from the server. Please try again.");
      } else {
        console.error("Error", error.message);
        alert("Something went wrong. Please try again.");
      }
    }
  };

  const validateEmail = (email) => {
    // Basic email validation regex
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  

  return (
    <ChakraProvider>
      <Box
        className="box"
        width="100%"
        margin="0 auto"
        padding="15px"
        borderWidth="1px"
        borderRadius="lg"
      >
        <form onSubmit={handleSubmit}>
          <FormControl id="firstName" mb="1" width="100%">
            <Input
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              placeholder="First Name"
              required
            />
          </FormControl>
          <FormControl id="lastName" mb="1" width="100%">
            <Input
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              placeholder="Last Name"
              required
            />
          </FormControl>
          <FormControl id="mobile" mb="1" width="100%">
          <>
      <MobileNumberInput
        country={country}
        countryDialCode={countryDialCode}
        phone={phone}
        setCountry={setCountry}
        setCountryDialCode={setCountryDialCode}
        setPhone={setPhone}
      />
    </>
            {/* <PhoneInput
              defaultCountry={defaultCountryCode}
              value={formData.mobile}
              onChange={handlePhoneChange}
              inputClass="chakra-input"
              containerStyle={{ width: "100%" }}
              inputStyle={{ width: "100%", boxSizing: "border-box" }}
              forceDialCode={true}
            /> */}
          </FormControl>
          <input type="hidden" name="isd" value={formData.isd} />
          <FormControl id="email" mb="1" width="100%">
            <Input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Email"
              required
              isInvalid={emailError}
            />
            {emailError && (
              <FormHelperText color="red">
                Please enter a valid email address.
              </FormHelperText>
            )}
          </FormControl>
          <FormControl id="company" mb="1" width="100%">
            <Input
              type="text"
              name="company"
              value={formData.company}
              onChange={handleChange}
              placeholder="Company"
              required
            />
          </FormControl>
          <FormControl id="industry" mb="1" width="100%">
            <Select
              placeholder="Select industry"
              name="industry"
              value={formData.industry}
              onChange={handleChange}
              required
              className="custom-select"
            >
              <option value="Apparel">Apparel</option>
              <option value="Banking">Banking</option>
              <option value="Biotechnology">Biotechnology</option>
              <option value="Chemicals">Chemicals</option>
              <option value="Communications">Communications</option>
              <option value="Construction">Construction</option>
              <option value="Entertainment">Entertainment</option>
              <option value="Environmental">Environmental</option>
              <option value="Manufacturing">Manufacturing</option>
              <option value="Retail">Retail</option>
              <option value="Utilities">Utilities</option>
            </Select>
          </FormControl>
          <Button
            className="submit"
            type="submit"
            backgroundColor="#fdb702"
            color="white"
          >
            REQUEST CALLBACK
          </Button>
        </form>
      </Box>
    </ChakraProvider>
  );
};

export default CallbackForm;
